import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../asset/logowhite.png";
import loginbg from "../asset/login/login.png";
import { FaArrowLeft } from "react-icons/fa";
import {
  MdPhone,
  MdEmail,
  MdVisibility,
  MdVisibilityOff,
} from "react-icons/md";
import SummaryApi from "../common";

const InstructorSignupOtp = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isOtpPhase, setIsOtpPhase] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    mobile_number: "",
    email: "",
    password: "",
    confirm_password: "", // <-- added this
    is_self_registered:1,
  });

  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputsRef = useRef([]);

  // ---------------- SIGNUP ----------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "mobile_number") {
      if (!/^\d*$/.test(value)) return;
      if (value.length > 10) return;
    }
    setFormData({ ...formData, [name]: value });
  };

  // const handleSignup = async (e) => {
  //   e.preventDefault();
  //   setIsLoading(true);
  //   const newErrors = {};

  //   if (!formData.first_name.trim())
  //     newErrors.first_name = "First name is required";
  //   if (!formData.last_name.trim())
  //     newErrors.last_name = "Last name is required";
  //   if (!formData.mobile_number)
  //     newErrors.mobile_number = "Mobile number is required";
  //   else if (!/^\d{10}$/.test(formData.mobile_number))
  //     newErrors.mobile_number = "Mobile number must be exactly 10 digits";
  //   if (!formData.email.trim()) newErrors.email = "Email is required";
  //   else if (!/\S+@\S+\.\S+/.test(formData.email))
  //     newErrors.email = "Invalid email format";

  //   if (!formData.password.trim()) newErrors.password = "Password is required";
  //   if (!formData.confirm_password.trim())
  //     newErrors.confirm_password = "Confirm password is required";
  //   else if (formData.password !== formData.confirm_password) {
  //     newErrors.confirm_password = "Passwords do not match";
  //     newErrors.password = "Passwords do not match";
  //   }

  //   if (Object.keys(newErrors).length > 0) {
  //     setErrors(newErrors);
  //     return;
  //   }

  //   setErrors({});

  //   try {
  //     const res = await fetch(SummaryApi.createInstructor.url, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(formData),
  //     });

  //     const data = await res.json();

  //     if (!res.ok || !data.status)
  //       throw new Error(data.message || "Failed to create instructor");

  //     toast.success(data.message);

  //     // Store email and mobile temporarily for OTP verification
  //     localStorage.setItem("instructor_email", formData.email);
  //     localStorage.setItem("instructor_mobile", formData.mobile_number);
  //     // Immediately show OTP input phase
  //     setFormData({
  //       first_name: "",
  //       last_name: "",
  //       mobile_number: "",
  //       email: "",
  //       password: "",
  //     });
  //     setIsOtpPhase(true);
  //   } catch (error) {
  //     toast.error(error.message);
  //   }
  //     setIsLoading(false);
  // };

  // ---------------- OTP ----------------
 
 
 
 
 
 
//  const handleSignup = async (e) => {
//   e.preventDefault();
//   setIsLoading(true);
//   const newErrors = {};

//   if (!formData.first_name.trim())
//     newErrors.first_name = "First name is required";
//   if (!formData.last_name.trim())
//     newErrors.last_name = "Last name is required";
//   if (!formData.mobile_number)
//     newErrors.mobile_number = "Mobile number is required";
//   else if (!/^\d{10}$/.test(formData.mobile_number))
//     newErrors.mobile_number = "Mobile number must be exactly 10 digits";
//   if (!formData.email.trim()) newErrors.email = "Email is required";
//   else if (!/\S+@\S+\.\S+/.test(formData.email))
//     newErrors.email = "Invalid email format";

//   if (!formData.password.trim()) newErrors.password = "Password is required";
//   if (!formData.confirm_password.trim())
//     newErrors.confirm_password = "Confirm password is required";
//   else if (formData.password !== formData.confirm_password) {
//     newErrors.confirm_password = "Passwords do not match";
//     newErrors.password = "Passwords do not match";
//   }

//   if (Object.keys(newErrors).length > 0) {
//     setErrors(newErrors);
//     setIsLoading(false);
//     return;
//   }

//   setErrors({});

//   try {
//     const res = await fetch(SummaryApi.createInstructor.url, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(formData),
//     });

//     const data = await res.json();

//     if (!res.ok || !data.status)
//       throw new Error(data.message || "Failed to create instructor");

//     toast.success(data.message);

//     // Save email + mobile for OTP phase
//     localStorage.setItem("instructor_email", formData.email);
//     localStorage.setItem("instructor_mobile", formData.mobile_number);

//     // ---------------------------------------------------
//     // ✅ SEND SMS HERE (using OTP returned from backend)
//     // ---------------------------------------------------

//     if (data.otp) {
//       await sendSmsOtp(formData.mobile_number, data.otp);
//       console.log("OTP SMS sent:", data.otp);
//     } else {
//       console.warn("⚠️ No OTP received from backend!");
//     }

//     // Switch to OTP phase
//     setFormData({
//       first_name: "",
//       last_name: "",
//       mobile_number: "",
//       email: "",
//       password: "",
//       confirm_password: "",
//     });

//     setIsOtpPhase(true);
//   } catch (error) {
//     toast.error(error.message);
//   }

//   setIsLoading(false);
// };

 
 const handleSignup = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  const newErrors = {};

  if (!formData.first_name.trim())
    newErrors.first_name = "First name is required";
  if (!formData.last_name.trim())
    newErrors.last_name = "Last name is required";
  if (!formData.mobile_number)
    newErrors.mobile_number = "Mobile number is required";
  else if (!/^\d{10}$/.test(formData.mobile_number))
    newErrors.mobile_number = "Mobile number must be exactly 10 digits";
  if (!formData.email.trim()) newErrors.email = "Email is required";
  else if (!/\S+@\S+\.\S+/.test(formData.email))
    newErrors.email = "Invalid email format";

  if (!formData.password.trim()) newErrors.password = "Password is required";
  if (!formData.confirm_password.trim())
    newErrors.confirm_password = "Confirm password is required";
  else if (formData.password !== formData.confirm_password) {
    newErrors.confirm_password = "Passwords do not match";
    newErrors.password = "Passwords do not match";
  }

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    setIsLoading(false);
    return;
  }

  setErrors({});

  try {
    const res = await fetch(SummaryApi.createInstructor.url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    const data = await res.json();

    if (!res.ok || !data.status)
      throw new Error(data.message || "Failed to create instructor");

    // Save email + mobile for OTP phase
    localStorage.setItem("instructor_email", formData.email);
    localStorage.setItem("instructor_mobile", formData.mobile_number);

    // ---------------------------------------------------
    //  SEND SMS USING BACKEND OTP
    // ---------------------------------------------------
    if (data.otp) {
      await sendSmsOtp(formData.mobile_number, data.otp);

      // ✅ Only this toast should appear
toast.success("OTP sent successfully to registered mail and mobile number");
    } else {
      console.warn("⚠️ No OTP received from backend!");
      toast.error("OTP not received — try again");
    }

    // Move to OTP Page
    setFormData({
      first_name: "",
      last_name: "",
      mobile_number: "",
      email: "",
      password: "",
      confirm_password: "",
    });

    setIsOtpPhase(true);

  } catch (error) {
    toast.error(error.message);
  }

  setIsLoading(false);
};

 
 
 
 
 
 
 
 
 
 
 
 
 
 
  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (!/^[0-9]?$/.test(value)) return;
    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);
    if (value && index < 3) inputsRef.current[index + 1]?.focus();
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };



  const sendSmsOtp = async (mobileNumber, otpValue) => {
    // We use the OTP returned from the backend, we do NOT generate a new one here
    // Construct the URL with the provided details
    const smsUrl = `https://sms.nettyfish.com/api/v2/SendSMS?SenderId=OAKYA&TemplateId=1707173313269381321&Message=Dear%20User%20your%20OTP%20${otpValue}%20for%20accessing%20admin%20panel%20-Oakya&PrincipleEntityId=1701172795416066262&ApiKey=ktTxImpILf3IA3lAdLt3sxLwpf0GUx41h9y%2BhU1LaWU=&ClientId=12eae6c0-7738-4f2a-afbe-77888ae20d0f&MobileNumbers=${mobileNumber}`;
    try {
      // mode: 'no-cors' is required because browsers block cross-origin requests to SMS gateways
      await fetch(smsUrl, {
        method: "GET",
        mode: "no-cors",
      });
      console.log("SMS Request Sent");
      return true;
    } catch (error) {
      console.error("SMS Error", error);
      return false;
    }
  };














const handleOtpSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true); // start loading
  const enteredOtp = otp.join("");
  const email = localStorage.getItem("instructor_email");

  try {
    const response = await fetch(SummaryApi.InstructorOtpVerification.url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, otp: enteredOtp }),
    });

    const data = await response.json();

    if (data.status) {
      toast.success("OTP verified successfully!");

      // Store instructor session info
      sessionStorage.setItem("instructor_id", data.instructor_id);
      sessionStorage.setItem("instructor_code", data.instructor_code || "");
      sessionStorage.setItem("login_identifier", email);
      sessionStorage.setItem("H7Z4L9VD2XK5JW8QRYT6", "active");

      localStorage.removeItem("instructor_email");
      localStorage.removeItem("instructor_mobile");

      const encodedInstructorId = btoa(data.instructor_id.toString());
      setTimeout(() => {
        navigate(
          `/instructor-panel/edit-instructor?id=${encodeURIComponent(
            encodedInstructorId
          )}`,
          { replace: true }
        );
      }, 1000);
    } else {
      toast.error(data.message || "OTP verification failed.");
    }
  } catch (error) {
    console.error("OTP verification error:", error);
    toast.error("Something went wrong. Please try again.");
  }

  setIsLoading(false); // stop loading
};


  return (
    <div className="min-h-screen w-full bg-white flex items-center justify-center p-4 sm:p-6">
                    <button
          onClick={() => window.history.back()}
          className="fixed top-10 left-4 z-50 flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-lg hover:shadow-xl transition-all border border-gray-200 dark:bg-gray-800 dark:border-gray-700"
          aria-label="Go back"
        >
          <FaArrowLeft className="text-2xl text-[#103b6b] dark:text-white" />
        </button>
      <div className="w-full max-w-7xl min-h-[650px] flex flex-col lg:flex-row rounded-3xl overflow-hidden shadow-lg">
        {/* Left Side */}
        <div className="w-full lg:w-1/2 relative min-h-[300px] lg:min-h-auto">
          <img
            src={loginbg}
            alt="Instructor Background"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-30" />
          <div className="relative z-10 flex items-center justify-center h-full p-4">
            {/* Clickable Logo */}
            <div
              onClick={() => navigate("/", { replace: true })}
              className="cursor-pointer transition-transform duration-200 hover:scale-105"
              title="Go to Home"
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && navigate("/", { replace: true })}
            >
              <img src={logo} alt="Logo" className="w-48 lg:w-64" />
            </div>
          </div>
        </div>

        {/* Right Side */}
        <div className="w-full lg:w-1/2 bg-white flex items-start justify-center p-4 sm:p-6 lg:p-6 lg:px-10">
          <div className="w-full max-w-md">
            {!isOtpPhase ? (
              <>
                <h2 className="text-3xl sm:text-4xl lg:text-[45px] font-bold text-blue-900 mb-4 sm:mb-6 text-center font-inter">
                  Create Instructor !
                </h2>
                <form className="space-y-4 sm:space-y-6" onSubmit={handleSignup}>
                  {/* First Name */}
                  <div>
                    <label
                      htmlFor="first_name"
                      className="block text-sm font-medium text-gray-700 font-inter mb-1"
                    >
                      First Name
                    </label>
                    <input
                      type="text"
                      id="first_name"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleChange}
                      placeholder="Enter your first name"
                      className={`w-full px-3 sm:px-4 py-1 sm:py-3 border ${
                        errors.first_name ? "border-red-500" : "border-gray-300"
                      } rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {errors.first_name && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.first_name}
                      </p>
                    )}
                  </div>

                  {/* Last Name */}
                  <div>
                    <label
                      htmlFor="last_name"
                      className="block text-sm font-medium text-gray-700 font-inter mb-1"
                    >
                      Last Name
                    </label>
                    <input
                      type="text"
                      id="last_name"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleChange}
                      placeholder="Enter your last name"
                      className={`w-full px-3 sm:px-4 py-1 sm:py-3 border ${
                        errors.last_name ? "border-red-500" : "border-gray-300"
                      } rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {errors.last_name && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.last_name}
                      </p>
                    )}
                  </div>

                  {/* Mobile */}
                  <div>
                    <label
                      htmlFor="mobile_number"
                      className="block text-sm font-medium text-gray-700 font-inter mb-1"
                    >
                      Mobile Number
                    </label>
                    <div className="relative">
                      <input
                        type="tel"
                        id="mobile_number"
                        name="mobile_number"
                        value={formData.mobile_number}
                        onChange={handleChange}
                        placeholder="Enter your mobile number"
                        maxLength="10"
                        className={`w-full px-3 sm:px-4 py-1 sm:py-3 border ${
                          errors.mobile_number
                            ? "border-red-500"
                            : "border-gray-300"
                        } rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 pl-9 sm:pl-10`}
                      />
                      <MdPhone className="absolute left-2 sm:left-3 top-2/4 transform -translate-y-1/2 text-gray-400 text-lg sm:text-xl" />
                    </div>
                    {errors.mobile_number && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.mobile_number}
                      </p>
                    )}
                  </div>

                  {/* Email */}
                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-gray-700 font-inter mb-1"
                    >
                      Email
                    </label>
                    <div className="relative">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}  // ← ONLY THIS LINE FIXED
                        onChange={handleChange}
                        placeholder="Enter your email"
                        className={`w-full px-3 sm:px-4 py-1 sm:py-3 pl-9 sm:pl-10 border ${
                          errors.email ? "border-red-500" : "border-gray-300"
                        } rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      />
                      <MdEmail className="absolute left-2 sm:left-3 top-2/4 transform -translate-y-1/2 text-gray-400 text-lg sm:text-xl" />
                    </div>
                    {errors.email && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.email}
                      </p>
                    )}
                  </div>

                  {/* Password */}
                  <div>
                    <label
                      htmlFor="password"
                      className="block text-sm font-medium text-gray-700 font-inter mb-1"
                    >
                      Password
                    </label>
                    <div className="relative">
                      <span
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute left-2 sm:left-3 top-2/4 transform -translate-y-1/2 cursor-pointer text-gray-400 text-lg sm:text-xl"
                      >
                        {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                      </span>
                      <input
                        type={showPassword ? "text" : "password"}
                        id="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder="Enter your password"
                        className={`w-full px-3 sm:px-4 py-1 sm:py-3 pl-9 sm:pl-10 pr-9 sm:pr-10 border ${
                          errors.password ? "border-red-500" : "border-gray-300"
                        } rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      />
                    </div>
                    {errors.password && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.password}
                      </p>
                    )}
                  </div>
                  {/* Confirm Password */}
                  <div>
                    <label
                      htmlFor="confirm_password"
                      className="block text-sm font-medium text-gray-700 font-inter mb-1"
                    >
                      Confirm Password
                    </label>
                    <div className="relative">
                      <span
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute left-2 sm:left-3 top-2/4 transform -translate-y-1/2 cursor-pointer text-gray-400 text-lg sm:text-xl"
                      >
                        {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                      </span>
                      <input
                        type={showPassword ? "text" : "password"}
                        id="confirm_password"
                        name="confirm_password"
                        value={formData.confirm_password}
                        onChange={handleChange}
                        placeholder="Re-enter your password"
                        className={`w-full px-3 sm:px-4 py-1 sm:py-3 pl-9 sm:pl-10 pr-9 sm:pr-10 border ${
                          errors.confirm_password
                            ? "border-red-500"
                            : "border-gray-300"
                        } rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      />
                    </div>
                    {errors.confirm_password && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.confirm_password}
                      </p>
                    )}
                  </div>

<button
  type="submit"
  disabled={isLoading}
  className={`w-full h-12 sm:h-12 ${
    isLoading ? "bg-blue-700 cursor-not-allowed" : "bg-blue-900 hover:bg-blue-800"
  } text-white font-semibold rounded-lg shadow-md transition duration-200 font-inter flex items-center justify-center gap-2`}
>
  {isLoading ? (
    <>
      {/* Spinner */}
      <svg
        className="animate-spin h-5 w-5 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>

      Processing...
    </>
  ) : (
    "NEXT"
  )}
</button>

                </form>
                <p className="mt-4 sm:mt-6 text-sm text-center text-gray-600 font-inter mb-4 sm:mb-[5%]">
              Not a member?{" "}
              <a
                href="/instructor-login"
                className="text-blue-900 font-medium hover:underline font-inter"
              >
                login
              </a>
            </p>
              </>
            ) : (
              <>
                <h2 className="text-2xl sm:text-3xl lg:text-[36px] font-bold text-blue-900 mb-6 sm:mb-10 text-center font-inter">
                  Enter OTP
                </h2>
                <form className="space-y-4 sm:space-y-6" onSubmit={handleOtpSubmit}>
                  <div className="flex justify-between gap-2 sm:gap-3 lg:gap-4">
                    {otp.map((digit, index) => (
                      <input
                        key={index}
                        type="text"
                        maxLength="1"
                        value={digit}
                        onChange={(e) => handleOtpChange(e, index)}
                        onKeyDown={(e) => handleOtpKeyDown(e, index)}
                        ref={(el) => (inputsRef.current[index] = el)}
                        className="w-12 h-14 sm:w-14 sm:h-16 text-center text-xl sm:text-2xl border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
                      />
                    ))}
                  </div>
<button
  type="submit"
  disabled={isLoading}
  className={`w-full py-2 sm:py-3 ${
    isLoading ? "bg-blue-700 cursor-not-allowed" : "bg-blue-900 hover:bg-blue-800"
  } text-white font-semibold rounded-lg shadow-md transition duration-200 font-inter flex items-center justify-center gap-2 mt-4 sm:mt-6`}
>
  {isLoading ? (
    <>
      <svg
        className="animate-spin h-5 w-5 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      Verifying...
    </>
  ) : (
    "VERIFY OTP"
  )}
</button>

                </form>
              </>
            )}
          </div>
        </div>
      </div>
      <ToastContainer position="top-center" autoClose={3000} />
    </div>
  );
};

export default InstructorSignupOtp;